export default function getNewsSlug(pathname: string) {
    const regex = /\/noticia\/(.+)/;
    const match = pathname.match(regex);
    return match ? match[1] : ""
}
